/*
 * What an organisation is to the platform, exactly as stanic-api spells it
 * (pkg/enums/OrganizationKind) — and, since every kind has a subdomain of its own, also
 * which portal the console was loaded from (pkg/enums/Portal: the same three words).
 *
 * The operator is Auto Stanić and sees every customer; a customer is a fleet he looks
 * after and sees only its own; a workshop maintains vehicles for him and sees only the
 * ones its open service cases assign it.
 */
export enum OrganizationKind {
    Operator = 'operator',
    Customer = 'customer',
    Workshop = 'workshop',
}

/** What kind of fleet a customer runs (pkg/enums/CustomerType). */
export enum CustomerType {
    RentACar  = 'rent_a_car',
    Transport = 'transport',
    Machinery = 'machinery',
    Other     = 'other',
}
